import axios from "axios";
import apiUrlOne from "../../utils.js/Config";

export const getCancellationPolicyTypes = async () => {
    try {
        const response = await axios.get(`${apiUrlOne}/cancellation-policy-types/get-all-cancellation-policy-types-admin`);
        return response.data;
    } catch (error) {
        console.error('Error fetching cancellation policy types:', error);
        throw error;
    }
};

export const getCancellationPolicyTypeById = async (id) => {
    try {
        const response = await axios.get(`${apiUrlOne}/cancellation-policy-types/${id}`);
        return response.data;
    } catch (error) {
        console.error(`Error fetching cancellation policy type with ID ${id}:`, error);
        throw error;
    }
};

export const createCancellationPolicyType = async (data) => {
    try {
        const response = await axios.post(`${apiUrlOne}/cancellation-policy-types`, data);
        return response.data;
    } catch (error) {
        console.error('Error creating cancellation policy type:', error);
        throw error;
    }
};

export const updateCancellationPolicyType = async (id, data) => {
    try {
        const response = await axios.put(`${apiUrlOne}/cancellation-policy-types/${id}`, data);
        return response.data;
    } catch (error) {
        console.error(`Error updating cancellation policy type with ID ${id}:`, error);
        throw error;
    }
};

export const deleteCancellationPolicyType = async (id) => {
    try {
        const response = await axios.delete(`${apiUrlOne}/cancellation-policy-types/${id}`);
        return response.data;
    } catch (error) {
        console.error(`Error deleting cancellation policy type with ID ${id}:`, error);
        throw error;
    }
};

// Refund Policy Tiers APIs
export const getRefundPolicyTiersByPolicyId = async (refundPolicyId) => {
    try {
        const response = await axios.get(`${apiUrlOne}/refund-policy-tiers/policy/${refundPolicyId}`);
        return response.data;
    } catch (error) {
        console.error(`Error fetching refund policy tiers for policy ID ${refundPolicyId}:`, error);
        throw error;
    }
};

export const saveRefundPolicyTiers = async (tiersData) => {
    try {
        const token = localStorage.getItem('accessToken');
        const headers = token ? { Authorization: `Bearer ${token}` } : {};
        const response = await axios.post(`${apiUrlOne}/refund-policy-tiers`, tiersData, { headers });
        return response.data;
    } catch (error) {
        console.error('Error saving refund policy tiers:', error);
        throw error;
    }
};

export const deleteRefundPolicyTier = async (id) => {
    try {
        const token = localStorage.getItem('accessToken');
        const headers = token ? { Authorization: `Bearer ${token}` } : {};
        const response = await axios.delete(`${apiUrlOne}/refund-policy-tiers/${id}`, { headers });
        return response.data;
    } catch (error) {
        console.error(`Error deleting refund policy tier ID ${id}:`, error);
        throw error;
    }
};

